import React, { useCallback, useEffect, useState } from 'react';
import { Box, Link, TableCell, TableRow, Typography } from '@mui/material';

// COMPONENTS
import CardWrapper from '../../CardWrapper';
import Loader from '../../../common/Loader';
import DashboardTable from '../../DashboardTable';

// MESSAGES
import HomeFormattedMessages from '../../../../messages/HomeFormattedMessages';

// REQUESTS
import useDashboardRequest from '../../../../requests/DashboardRequest';

export default function TopFiveUsers({ navigate, mobileView, errorHandler }) {
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getCustomerTopFiveUsers } = useDashboardRequest();

  const columns = [
    { id: 'email', label: 'Email' },
    { id: 'dedicatednumber', label: 'Dedicated Number' },
    { id: 'costcentre', label: 'Cost Centre' },
    { id: 'max', label: 'Max Msgs./Day', align: 'right' },
    { id: 'send', label: 'Msgs. Send', align: 'right' },
  ];

  const loadData = useCallback(async () => {
    if (!mobileView) {
      setLoading(true);
      const response = await getCustomerTopFiveUsers(errorHandler);
      setUserData(response);
    }
    setLoading(false);
  }, [mobileView]);

  const handlePageNavigation = (item, option) => {
    if (option === 'email') navigate(`/account/users/${item.customer_user_id}`);
    if (option === 'sends') {
      localStorage.setItem('timeRange', '24 hrs');
      navigate('/reports/user', {
        state: {
          userData: { customer_user_id: item.customer_user_id },
        },
      });
    }
  };

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <CardWrapper
      title={HomeFormattedMessages.topUsers}
      subtitle={HomeFormattedMessages.last24Hours}
      icon="contact"
      goToLink="/reports/user"
      goToLinkText="Go to User Reports"
      goToLinkSetTimeRange="24 hrs"
      navigate={navigate}
    >
      {loading ? (
        <Loader />
      ) : userData.length === 0 && !mobileView ? (
        <Box sx={{ marginTop: 2 }}>
          <Typography>{HomeFormattedMessages.noDataAvailable}</Typography>
        </Box>
      ) : !mobileView ? (
        <Box>
          <DashboardTable columns={columns}>
            {userData.map((item, index) => (
              <TableRow key={`row_${index}`}>
                <TableCell>
                  <Link
                    component="button"
                    onClick={() => handlePageNavigation(item, 'email')}
                  >
                    {item.Email}
                  </Link>
                </TableCell>
                <TableCell>{item['Dedicated Number'] || 'N/A'}</TableCell>
                <TableCell>{item['Cost Centre']}</TableCell>
                <TableCell align="right">{item['Max. Msgs./Day']}</TableCell>
                <TableCell align="right">
                  <Link
                    component="button"
                    onClick={() => handlePageNavigation(item, 'sends')}
                  >
                    {item['Msgs Send']}
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </DashboardTable>
        </Box>
      ) : null}
    </CardWrapper>
  );
}
